<template>
  <aside class="sidebar">
    <div class="sidebar-header">
      <div class="logo">
        <img src="/images/logo.png" alt="DMS Logo" class="logo-image">
        <span class="logo-text">DMS</span>
      </div>
      <p class="logo-subtitle">Automatisation intelligente</p>
    </div>
    
    <nav class="sidebar-nav">
      <ul class="nav-list">
        <li class="nav-item">
          <router-link to="/" class="nav-link" :class="{ active: $route.name === 'Dashboard' }">
            <i class="fas fa-chart-line"></i>
            <span>Dashboard</span>
          </router-link>
        </li>
        
        <li class="nav-item">
          <router-link to="/emails" class="nav-link" :class="{ active: $route.name === 'Emails' }">
            <i class="fas fa-envelope"></i>
            <span>Messages</span>
          </router-link>
        </li>
        
        <li class="nav-item">
          <router-link to="/customers" class="nav-link" :class="{ active: $route.name === 'Customers' }">
            <i class="fas fa-users"></i>
            <span>Clients</span>
          </router-link>
        </li>
        
        <li class="nav-item">
          <router-link to="/produits" class="nav-link" :class="{ active: $route.name === 'Produits' }">
            <i class="fas fa-box"></i>
            <span>Produits</span>
          </router-link>
        </li>
        
        <li class="nav-item">
          <router-link to="/transporteurs" class="nav-link" :class="{ active: $route.name === 'Transporteurs' }">
            <i class="fas fa-truck"></i>
            <span>Transporteurs</span>
          </router-link>
        </li>
        
        <li class="nav-item">
          <router-link to="/about" class="nav-link" :class="{ active: $route.name === 'About' }">
            <i class="fas fa-info-circle"></i>
            <span>À Propos</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link to="/analytics" class="nav-link" :class="{ active: $route.name === 'Analytics' }">
            <i class="fas fa-chart-bar"></i>
            <span>Analytics</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link to="/notification-channels" class="nav-link" :class="{ active: $route.name === 'NotificationChannels' }">
            <i class="fas fa-bell"></i>
            <span>Notifications</span>
          </router-link>
        </li>

        <li class="nav-item">
          <router-link to="/settings" class="nav-link" :class="{ active: $route.name === 'OrganisationSettings' }">
            <i class="fas fa-cog"></i>
            <span>Settings</span>
          </router-link>
        </li>
      </ul>
      
      <div class="sidebar-footer">
        <div class="user-info">
          <div class="user-avatar">
            <i class="fas fa-user"></i>
          </div>
          <div class="user-details">
            <span class="user-name">{{ currentUser?.name || 'Utilisateur' }}</span>
            <span class="user-role">{{ currentUser?.role || 'Admin' }}</span>
          </div>
        </div>
        
        <button @click="logout" class="logout-btn">
          <i class="fas fa-sign-out-alt"></i>
          <span>Déconnexion</span>
        </button>
      </div>
    </nav>
  </aside>
</template>

<script>
import { useAuthStore } from '../stores/auth'
import { computed } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'Sidebar',
  setup() {
    const authStore = useAuthStore()
    const router = useRouter()
    
    const currentUser = computed(() => authStore.user)
    
    const logout = () => {
      authStore.logout()
      router.push('/login')
    }
    
    return {
      currentUser,
      logout
    }
  }
}
</script>

<style scoped>
.sidebar-header {
  padding: 0 2rem 1.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
}

@media (max-width: 991.98px) {
  /* Le logo est déjà dans la barre supérieure */
  .sidebar-header {
    display: none;
  }
}

.logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
}

.logo-image {
  width: 80%;
  max-width: 150px;
  height: auto;
  margin-bottom: 8px;
}

.logo-text {
  font-size: 1.4rem;
  font-weight: bold;
  color: white;
  text-align: center;
}

.logo-subtitle {
  font-size: 0.8rem;
  color: #718096;
  margin: 0;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
}

.sidebar-footer {
  padding: 1rem 2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.user-info {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 8px;
}

.user-avatar {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
}

.user-avatar i {
  color: white;
  font-size: 1rem;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: 600;
  color: #2d3748;
  font-size: 0.9rem;
}

.user-role {
  font-size: 0.8rem;
  color: #718096;
}

.logout-btn {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 44px;
  padding: 0.75rem;
  background: none;
  border: 1px solid rgba(245, 101, 101, 0.3);
  border-radius: 8px;
  color: #f56565;
  cursor: pointer;
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background: rgba(245, 101, 101, 0.1);
  border-color: #f56565;
}

.logout-btn i {
  margin-right: 0.5rem;
}
</style>